import { CenteredBox } from 'components/styles_components/container';
import { CircularProgress } from 'components/ui';

const Loader = () => {
  return (
    <CenteredBox>
      <CircularProgress />
    </CenteredBox>
  );
};

export default Loader;
